import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import { useLang } from "../lib/i18n";

// Harmonized "next step" CTA. Purely presentational: navigates to an EXISTING
// route via onClick. No data mutation, no AI call.
export function NextStepCta({ description, ctaLabel, onClick, testid = "next-step-cta" }) {
  const { t } = useLang();
  return (
    <div className="lb-card p-5 border-neon/20 mt-6" data-testid={testid}>
      <p className="text-[11px] uppercase tracking-wide text-neon font-semibold mb-1.5">{t("next_step_label")}</p>
      {description && <p className="text-sm text-[hsl(var(--muted-foreground))] mb-4">{description}</p>}
      <Button onClick={onClick} data-testid={`${testid}-btn`}
        className="w-full sm:w-auto rounded-full h-12 px-6 bg-gradient-to-r from-primary to-neon text-white lb-glow-btn font-semibold text-sm">
        {ctaLabel} <ArrowRight size={16} className="ml-1.5" />
      </Button>
    </div>
  );
}
